import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';

export const Projects = () => {

  const projectsLanding = [
	  {
		  title: "ТПП Г-К АНАПА",
		  description: "Front-end development | 2023",
		  imgUrl: '/proj/join-the-tpp-anapa.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/join-the-tpp-anapa",
	  },
	  {
		  title: "7 Days Studio",
		  description: "Front-end development | 2023",
		  imgUrl: '/proj/seven-days-studio.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/seven-days-studio",
	  },
	  {
		  title: "Жетiсу Логистикс",
		  description: "Front-end development | 2023",
		  imgUrl: '/proj/jtld.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/jtld",
	  },
	  {
		  title: "Чистый том для PetStore",
		  description: "Front-end development | 2023",
		  imgUrl: '/proj/tom-petstore.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/tom-petstore",
	  },
	  {
		  title: "ТПП Г-К АНАПА",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/tpp-anapa.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/tpp-anapa",
	  },
	  {
		  title: "Botaqan",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/Botaqan.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/Botaqan",
	  },
	  {
		  title: "Well Way",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/wellway.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/wellway",
	  },
	  {
		  title: "Dalab Logo",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/dalab-logo.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/dalab-logo",
	  },
	  {
		  title: "Марафон «Тюльпановый рай»",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/Zarubina.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/Zarubina",
	  },
	  {
		  title: "Азиатский Шмель",
		  description: "Front-end development | 2022",
		  imgUrl: '/proj/Shmel.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/Shmel",
	  },
	  {
		  title: "ТПП Г-К АНАПА",
		  description: "Front-end development | 2023",
		  imgUrl: '/proj/tpp-anapa-two.jpg',
		  viewUrl: "https://vladislavvlasov.github.io/tpp-anapa-two",
	  },
  ];

	const projectsMulti = [
		{
			title: "Технопоиск",
			description: "Front-end development | 2023",
			imgUrl: "proj/texno-poisk.jpg",
			viewUrl: "https://vladislavvlasov.github.io/texno-poisk/preview.html",
		},
		{
			title: "Aqua Style",
			description: "Design & Development | 2020",
			imgUrl: "proj/aqua-style.jpg",
			viewUrl: "https://aqua-style.uz",
		},
	];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
              <div className="animate__animated animate__fadeIn">
                <h2>Projects</h2>
                <p>These are my commercial projects that I have developed.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">All</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Landing</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Multi-page</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className="animate__animated animate__slideInUp">
                    <Tab.Pane eventKey="first">
                      <Row>
	                      {
		                      projectsLanding.map((project, index) => {
			                      return (
				                      <ProjectCard
					                      key={index}
					                      {...project}
				                      />
			                      )
		                      })
	                      }
	                      {
		                      projectsMulti.map((project, index) => {
			                      return (
				                      <ProjectCard
					                      key={index}
					                      {...project}
				                      />
			                      )
		                      })
												}
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
	                    <Row>
		                    {
			                    projectsLanding.map((project, index) => {
				                    return (
					                    <ProjectCard
						                    key={index}
						                    {...project}
					                    />
				                    )
			                    })
		                    }
	                    </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
	                    <Row>
		                    {
			                    projectsMulti.map((project, index) => {
				                    return (
					                    <ProjectCard
						                    key={index}
						                    {...project}
					                    />
				                    )
			                    })
		                    }
	                    </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
    </section>
  )
}
